export default {
  errorsRootKey: 'products',
  resource: 'products',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
